type UnarchiveActionIconProps = {
  className?: string;
};

export default function UnarchiveActionIcon({ className }: UnarchiveActionIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="16"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M13 12H23"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 12V22C14 22.3536 14.1405 22.6928 14.3905 22.9428C14.6406 23.1929 14.9797 23.3333 15.3333 23.3333H20.6667C21.0203 23.3333 21.3594 23.1929 21.6095 22.9428C21.8595 22.6928 22 22.3536 22 22V12"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12V10.6667C16 10.313 16.1405 9.97391 16.3905 9.72386C16.6406 9.47381 16.9797 9.33333 17.3333 9.33333H18.6667C19.0203 9.33333 19.3594 9.47381 19.6095 9.72386C19.8595 9.97391 20 10.313 20 10.6667V12"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 20V15"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17L18 15L20 17"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
